import { ThemeOption } from 'themes';

export default function componentStyleOverrides(theme: ThemeOption) {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    borderRadius: '5px',
                },
                contained: {
                    color: theme.colors?.white,
                    boxShadow: 'none',

                    '&:hover': {
                        color: theme.colors?.white,
                        boxShadow: 'none',
                    },
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
                rounded: {
                    borderRadius: '6px',
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    padding: '24px',
                },
                title: {
                    fontSize: '1.125rem',
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '24px',
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px',
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    paddingTop: '6px',
                    paddingBottom: '6px',
                    '&.Mui-selected': {
                        color: theme.menuSelected,
                        backgroundColor: theme.menuSelectedBack,
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack,
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected,
                        },
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected,
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected,
                        },
                    },
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    minWidth: '36px',
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: theme.darkTextPrimary,
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    fontWeight: 500,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.darkTextPrimary,
                    '&::placeholder': {
                        color: theme.darkTextPrimary,
                    },
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300,
                    },
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px',
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight,
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primary200,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    boxShadow: theme.boxShadow,
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit',
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.backgroundDefault,
                    background: theme.darkTextPrimary,
                },
            },
        },
        MuiDialogTitle: {
            defaultProps: {
                variant: 'h3',
            },
            styleOverrides: {
                root: {},
            },
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                },
            },
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderColor: `${theme.divider} !important`,
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {},
                icon: {
                    color: theme.darkTextPrimary,
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {},
                toolbar: {
                    padding: 0,
                },
            },
        },
    };
}
